import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { ConditionalWrapper } from '@cian/conditional-component';
/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, ArticleHeading1, UIText1 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';
import cn from 'clsx';
import { useSelector } from 'react-redux';

import { NBSP } from '../../constants/symbols';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectAbUseExperiments } from '../../selectors/selectAbUseExperiments';
import { isAbExperiment } from '../../utils/abuse';
import { FIND_REALTOR_FORM_START } from '../../constants/experiments';

import * as styles from './styles.css';

export interface IIntroProps {
  submitText?: string;
  onSubmit(): void;
}

const OLD_CONTENT = {
  title: 'Бесплатно подберем\nнадежного риелтора',
  list: [
    `Заполните короткую анкету. Это${NBSP}займет не${NBSP}более 3${NBSP}минут`,
    `Мы отправим анкету риелторам, которые${NBSP}сотрудничают с нами`,
    `Вам позвонит не более 3 риелторов. Они${NBSP}уточнят детали и${NBSP}ответят на${NBSP}вопросы`,
    `Вы${NBSP}обсудите условия сотрудничества,${NBSP}стоимость услуг и${NBSP}выберите подходящего риелтора`,
  ],
};

const NEW_CONTENT = {
  title: 'Бесплатно подберём\nнадёжного риелтора',
  list: [
    `Заполните короткую анкету — это${NBSP}займёт пару минут`,
    `По${NBSP}анкете вам${NBSP}перезвонят максимум 3${NBSP}риелтора: обсудите детали и${NBSP}цены`,
    `Выберете подходящего риелтора и${NBSP}начнёте работу`,
  ],
};

export function Intro({ submitText = 'Заполнить анкету', onSubmit }: IIntroProps) {
  const isMobile = !useIsDesktop();
  const isNewFormStart = isAbExperiment(useSelector(selectAbUseExperiments), FIND_REALTOR_FORM_START, 'B');
  const applicationContext = useApplicationContext();
  const updateApplicationEnabled = applicationContext.config.get<boolean>('demand.ApplicationFormV5.Enabled') || false;
  const content = isNewFormStart ? NEW_CONTENT : OLD_CONTENT;

  return (
    <div className={styles['container']}>
      <div>
        {isMobile && <div className={cn(styles['img'], updateApplicationEnabled && styles['new-img'])} />}
        <div className={styles['title']}>
          <ConditionalWrapper if={isMobile} ThenComponent={ArticleHeading1} ElseComponent={Header0}>
            <span>{content.title}</span>
          </ConditionalWrapper>
        </div>
        <ul className={styles['list']}>
          {content.list.map((item, index) => (
            <li key={index} className={styles['list-item']}>
              <span className={styles['marker']}>
                <UIText1>{index + 1}</UIText1>
              </span>
              <UIText1>{item}</UIText1>
            </li>
          ))}
        </ul>
        <div className={styles['button-sticky']} data-testid="quizStart">
          <Button theme="fill_primary" size="M" onClick={onSubmit} fullWidth={isMobile}>
            {submitText}
          </Button>
        </div>
      </div>
    </div>
  );
}
